import { getRTFlightCouponsData, getSearchResult, airportSearchBluk, getWowPricingSrpData } from '@/api/srp'
import { getCleartripScriptOrigin } from '@/utils/general/cleartripOrigin'
import { getScript } from '@/utils/general/browserHelper'
import { fetchVisaDenialEligibilityData, getVisaDenialAvailable, resetVisaDenialState } from '@/redux/slices/visaDenial'
import { createVisaDenialPayload, isInternationalSector } from '@/utils/homepage/visaDenialHelper'
import FindingFlightsLoader from '@/components/srp/Loaders/FindingFlightsLoader'
import FiltersLoader from '@/components/srp/Loaders/FiltersLoader'
import ModifySearchWidget from '@/components/srp/ModifySearch'
import SearchError from '@/components/srp/SearchError'
import SortOptions from '@/components/srp/SortOptions'
import TuppleRenderer from '@/components/srp/TuppleRenderer'
import { resolveRevampPtcStripType } from '@/constants/components/fareType'
import { DATE_ERROR, filterTypes, INTL_RT_CONTAINER_WIDTH, SEARCH_NO_FLIGHTS_AVAILABLE, SRP_REVAMP_BAND_SHADOW, SRP_REVAMP_RESULTS_WIDTH, SRP_REVAMP_SHELL_CSS, STUDENT_FARE_TOAST_MESSAGE } from '@/constants/Srp'
import useFilteredCards from '@/hooks/srp/useFilteredCards'
import useSortedCards from '@/hooks/srp/useSortedCards'
// Sorting will be handled locally per provided implementation
import {
    getSrpSearchData,
    setCouponsData,
    setError,
    setSrpSearchData,
    updateFaresPricing,
    setDynamicContentLoading,
    addWowLoadingFareIds,
    removeWowLoadingFareIds,
    getSelectedFilters,
    setSelectedFilters,
    getWowFares,
    getIsDynamicContentLoading,
    getSearchSubTravelOptions
} from '@/redux/slices/srpSlice'
import { RT_MASTER_WOW_LOADING_ID } from '@/constants/Srp'
import useProgressiveWowPricing from '@/hooks/srp/useProgressiveWowPricing'
import useWowPricingExperiment from '@/hooks/srp/useWowPricingExperiment'
import { collapseSamePriceCards, isProgressiveWowEnabled } from '@/utils/srp/wow'
import { getFetchContentPayload } from '@/utils/srp/wowPayload'
import { isUserSignedIn } from '@/utils/general/user'
import { useAppDispatch, useAppSelector } from '@/redux/store/hooks'
import { FilterData, OfferType, QueryParamsData, SortOptionType, StudentFareFilterProps } from '@/types/srp'
import { getCollectionRegisterationInfo, isServer, storeUtmParams } from '@/utils'
import { deepEqual, isFFFlowEnabled } from '@/utils/common'
import { isEmpty, replaceQueryInUrl } from '@/utils/general/browserHelper'
import { processQueryParams, searchQueryUrl, formAirportList, pushSearchQueryUrl, isCheckInBaggageEnabled, getPtcFilterDetails } from '@/utils/srp'
import {
    createCopunsPayload,
    getFFCookieValue,
    getMasterTuppleProps,
    getSearchIntentDetails,
    isPerAdultPricing
} from '@/utils/srp/helper'
import { Container, Divider, Spacer } from '@cleartrip/ct-design-components'
import { useRouter } from 'next/router'
import { useEffect, useMemo, useRef, useState } from 'react'
import startOfDay from 'date-fns/startOfDay'
import parseDate from 'date-fns/parse'
import differenceInDays from 'date-fns/differenceInDays'
import { ravenSDKSrpCfwTrigger } from '@/analytics/raven/ravenSDKHelper'
import { getSrpWalletBalance } from '@/analytics/raven/wowPricingInstrumentation'
import { RAVEN_EVENT_NAME } from '@/analytics/raven/ravenConstants'
import dayjs from 'dayjs'
import dynamic from 'next/dynamic'
import { trackRumEvent, setRumPage, RUM_EVENT, RUM_FAILURE_REASON, getSrpRumContext } from '@/analytics/sparkloom'
import EmiCallout from '@/components/srp/EmiCallout '
import IntlRTSort from '@/components/srp/IntlRTSort'
import { Collapse } from '@/components/Collapse/Collapse'
import SrpEmiBanksPopup from '@/components/srp/SrpEmiBanksPopup'
import { isFeatureEnabled } from '@/utils/general/uiHelper'
import StudentFareFilter from '@/components/srp/Filters/StudentFareFilter'
import PtcError from '@/components/srp/Error/PtcError'
import { SENTRY_METRICS_CONFIG, type CountMetricName } from '@/constants/analytics/sentryCountMetrics'
import { countMetric, getSrpMetricAttributes } from '@/utils/analytics/sentry/metrics'
import { registerUserToCollection } from '@/api/homepage'
import DateSelectorWrapper from '@/components/srp/DateSelectorWrapper'
import Filters from '@/components/srp/Filters'
import usePremiumEconomyExperiment from '@/hooks/flights/usePremiumEconomyExperiment'
import PESrpHero from '@/components/srp/PESrpHero'
import SortBarOneWay from '@/components/srp/SortOptions/SortBarOneWay'
import SortOptionsFFOW from '@/components/srp/SortOptionsFF/OW'
import SortOptionsFFRT from '@/components/srp/SortOptionsFF/RT'
import SrpCouponsBar from '@/components/srp/SrpCouponsBar'
import { PtcFareTopCallout, PtcTupleRenedrer } from '@/components/srp/Tupple/Domestic/CommonComponents/PtcFareCallout'
import Toast from '@/components/Toast'
import { isSrpFirstClassCabin, isSrpThemeCabin, getSrpHeroTheme } from '@/constants/flights/premiumEconomy'
import useSpecialFareCards from '@/hooks/srp/useSpecialFareCards'
import { getUserProfileDetails } from '@/utils/experiment/phoneNumberWhitelisting'

const MasterTupple = dynamic(() => import(/* webpackChunkName: "MasterTupple" */ '@/components/srp/MasterTupple'), {
    loading: () => <></>
})
const LEGACY_FILTER_RAIL_CSS = { width: '290px' }

const MasterTuppleFareFamilyDomestic  = dynamic(() => import(/* webpackChunkName: "MasterTuppleFareFamilyDomestic" */ '@/components/srp/MasterTupple/fareFamilyDomestic'), {
loading: () => <></>
})
type SrpContainerProps = {
    srpCouponList: OfferType[]
    initialTS: number
    fareType?: string
    pageScrollRef?: React.RefObject<HTMLDivElement>
    onCollapseSetHeaderState?: (state: 'open' | 'collapsed') => void
    isSrpRevamp?: boolean
}

const SrpContainer: React.FC<SrpContainerProps> = ({ srpCouponList, initialTS, fareType = '', pageScrollRef, onCollapseSetHeaderState, isSrpRevamp = false }) => {
    let router = useRouter()
    const dispatch = useAppDispatch()
    
    const { isPeTestVariant, loading: isPeVariantLoading } = usePremiumEconomyExperiment()
    const showPeSrpHero = !isPeVariantLoading && isPeTestVariant

    // Collapse state management for international round trip
    const [collapseState, setCollapseState] = useState<'open' | 'collapsed'>('open')
    const resultsRowRef = useRef<HTMLDivElement>(null)
    const handleCollapseStateChange = (state: 'open' | 'collapsed') => {
        const pageShell = pageScrollRef?.current
        if (isSrpRevamp && pageShell && resultsRowRef.current) {
            // Coming back up is left to the browser: past the top of a leg the wheel chains into the page, so the
            // header returns 1:1 with the user's scroll instead of an animation fighting their input.
            if (state === 'open') return
            // Going down: scroll the page shell until the results row fills the viewport, instead of collapsing the
            // header. Scrolling is composited, so there is no layout shift and nothing re-renders.
            const rowTop = resultsRowRef.current.getBoundingClientRect().top - pageShell.getBoundingClientRect().top + pageShell.scrollTop
            // Already past the header (the user scrolled on towards the footer): don't pull the page back up.
            if (pageShell.scrollTop >= rowTop) return
            pageShell.scrollTo({ top: rowTop, behavior: 'smooth' })
            return
        }
        setCollapseState(state)
        onCollapseSetHeaderState?.(state)
    }
    const { searchData, srpError, isLoading: isStoreDataLoading, couponData,responseStatusCode } = useAppSelector(getSrpSearchData)
    const wowFares = useAppSelector(getWowFares) || {}
    const isDynamicContentLoading = useAppSelector(getIsDynamicContentLoading)
    const {
        cards,
        sortData,
        filterData,
        metaData,
        subTravelOptions,
        fares,
        searchIntent,
        specialRTFareMap,
        dataId,
        searchId,
        supercoins = {}
    } = searchData

    const { paxCriteria = [], J1from = '', J2from = '' } = getSearchIntentDetails(searchIntent)
    const showPerAdultPricing = isPerAdultPricing(paxCriteria)
    let data = router.query as unknown as QueryParamsData
    const calculateDateFromDx = (dxValue: string) => {
        const daysToAdd = parseInt(dxValue, 10);
        if (isNaN(daysToAdd)) {
          return null;
        }
        return dayjs().add(daysToAdd, 'day').format('DD/MM/YYYY');
      };

    const processedData = useMemo(() => {
        const processed = processQueryParams(router, data)
        if(!data.depart_date && data.dx){
            const calculatedDate = calculateDateFromDx(data.dx)
            if (calculatedDate) {
                processed.departDate = calculatedDate
            }
        }
        return processed
    }, [router.query])
    const { isIntl = false } = processedData || {}
    const { wowPricingVariant, wowOn: wowPricingEnabled } = useWowPricingExperiment(!!isIntl)
    const { API_SRP_ERROR, FUNNEL_SRP_LOADED, FUNNEL_SRP_STARTED } = SENTRY_METRICS_CONFIG
    const queryDataForFilters = {
        departDate: processedData.departDate,
        destination: processedData.destination || '',
        flightClass: processedData.flightClass,
        isIntl: processedData.isIntl,
        returnDate: processedData.returnDate || '',
        source: processedData.source || '',
        travellers: processedData.travellers,
        tripType: processedData.tripType,
        isCfw: processedData.isCfw
    }
    const { returnDate } = processedData
    // FF/CFW UI is driven by the page-level fareType: domestic CFW is the only
    // non-FF flow. International (incl. intl CFW) always uses fareType 'FF', so it
    // renders the same fare-family master tupple/summary as the FF flow.
    const isFareFamilyFlow = fareType === 'FF'

    const srpContext = useMemo(
        () => getSrpRumContext(processedData),
        [processedData.isIntl, processedData.returnDate, processedData.departDate]
    )

    const [selectedFlights, setSelectedFlights] = useState<any>([])
    const [places, setPlacesSearch] = useState({})
    const [airportSearchBlukResponse, setAirportSearchBlukResponse] = useState<any>(null)
    // Initialize searchQuery with router.query and processedData.isCfw to prevent ModifySearch from initializing with false
    const [searchQuery, setSearchQuery] = useState(() => {
        const query = router.query as unknown as QueryParamsData
        return { ...query, isCfw: processedData.isCfw, sft: processedData.sft }
    })
    //const [processedData, setProcessedData] = useState({})
    const [isCouponApiLoading, setIsCouponApiLoading] = useState<boolean>(false)
    const [isSearchApiLoading, setIsSeachApiLoading] = useState<boolean>(true)
    const [originalFilterData, setOriginalFilterData] = useState<any>({}) // Immutable API response
    const [activeSort, setActiveSort] = useState<SortOptionType[]>([
        { title: 'Cheapest', sortType: 'asc', sortingBasis: 'price', sortKey: 'price_up' },
        { title: 'Cheapest', sortType: 'asc', sortingBasis: 'price', sortKey: 'price_up' }
    ])
    const selectedFilters = useAppSelector(getSelectedFilters) || {}
    const [selectedPrice, setSelectedPrice] = useState<Number>()
    const [toastMsg, setToastMsg] = useState("")
    const toastTimer = useRef<NodeJS.Timeout>()
    const masterTuppleRef = useRef<HTMLDivElement>(null)
    // De-duplicate WOW pricing fetches keyed by (dataId | selectedFlightsKey).
    // Re-renders / StrictMode-style double effects / race conditions can
    // otherwise trigger /flight/v2/fetch-dynamic-content multiple times for
    // the same logical state.
    const wowFetchedKeysRef = useRef<Set<string>>(new Set())
    const wowImpressionFiredRef = useRef(false)
    const sftFareType = searchQuery?.sft
    const [showEmi, setShowEmi] = useState(false)
    const [updatedReturnListLength, setUpdatedReturnListLength] = useState<number>(0)
    const [showAnimation, setShowAnimation] = useState(false)
    const hasShownEmiTooltipRef = useRef<boolean>(false)
    const [isNonStopDefaultApplied, setIsNonStopDefaultApplied] = useState(false)
    
    // Get non-stop default sectors from feature flag
    const { nonStopDefaultSectors = [] } = isFeatureEnabled() || {}
    const visaDenialTimeoutRef = useRef<NodeJS.Timeout | null>(null)
    const isVisaDenialAvailable = useAppSelector(getVisaDenialAvailable)
    const lastVisaDenialParamsRef = useRef<string>('')
    const { onwardFilterPtcType, returnFilterPtcType } = getPtcFilterDetails(selectedFilters)
    const { onwardLeg: onwardLegFilters, returnLeg: returnLegFilters } = selectedFilters || {}
    
    useEffect(() => {
        if (!showEmi) {
            hasShownEmiTooltipRef.current = false
        }
    }, [showEmi])
    const isRT = !isEmpty(searchQuery) ? !isEmpty(searchQuery.return_date) : !isEmpty(returnDate)
  const showStudentFareQuickFilter = isRT
    ? onwardLegFilters?.ptcFare?.enabled && returnLegFilters?.ptcFare?.enabled
    : onwardLegFilters?.ptcFare?.enabled
    
    // Check if current sector is in the non-stop default sectors list or nonStop is in query params
    const isNonStopDefaultSector = () => {
        const destination = processedData?.destination // e.g., "BOM"
        const origin = processedData?.source // e.g., "DEL"
        // Check if nonStop is in query params (from homepage toggle)
        const nonStopFromQuery = data?.nonStop === "true" || data?.nonStop === true
        return nonStopFromQuery || (!isEmpty(nonStopDefaultSectors) && nonStopDefaultSectors.includes(`${origin} - ${destination}`) ? true : false)
    }
    
    // Apply non-stop filter to both legs
    const applyNonStopDefaultFilter = (sanitizedFilterData: FilterData) => {
        // Check if non-stop flights are available before applying the filter
        const isNonStopAvailableOnward = sanitizedFilterData?.onwardLeg?.stops?.options?.includes(0) || false
        const isRoundTrip = !isEmpty(processedData?.returnDate)
        const isNonStopAvailableReturn = isRoundTrip 
            ? (sanitizedFilterData?.returnLeg?.stops?.options?.includes(0) || false)
            : true // For one-way, return leg check is not needed
        
        // Don't apply filter if non-stop is not available
        // For one-way: only check onward leg
        // For round trip: check both onward and return legs
        if (!isNonStopAvailableOnward || (isRoundTrip && !isNonStopAvailableReturn)) {
            return sanitizedFilterData
        }
        
        return {
            ...sanitizedFilterData,
            onwardLeg: sanitizedFilterData?.onwardLeg ? {
                ...sanitizedFilterData.onwardLeg,
                stops: {
                    ...(sanitizedFilterData.onwardLeg?.stops || {}),
                    selectedValues: [0] // 0 = Non-stop
                }
            } : {},
            returnLeg: sanitizedFilterData?.returnLeg ? {
                ...sanitizedFilterData.returnLeg,
                stops: {
                    ...(sanitizedFilterData.returnLeg?.stops || {}),
                    selectedValues: [0] // 0 = Non-stop
                }
            } : {}
        }
    }
    
    const handleNonStopTooltipDismiss = () => {
        setIsNonStopDefaultApplied(false)
    }

    const { filteredCards, totalFlightsCount, filteredFlightsCount,onewayFilteredFlightsCount, cheapestFilteredFlight, fastestFilteredFlight } = useFilteredCards({
        cards,
        selectedFilters,
        isStoreDataLoading,
        isRT,
        subTravelOptions,
        fares,
        isPerAdult: showPerAdultPricing,
        filterData
    })
    const { sortedCards: sortedFilteredCards, unModifiedCards: unModifiedSortedFilteredCards } = useSortedCards({ isSearchApiLoading, activeSort, filteredCards, sortData, processedData, selectedFilters })
    const {
        ptcFareCards,
        sortedFilteredCardsNoPTC,
        isPtc,
        cheapestRegularFare,
        isOnwardPtcFareAvailable,
        isReturnPtcFareAvailable,
        ptcAvailability,
    } = useSpecialFareCards({sortedFilteredCards, fares, subTravelOptions, isRT, processedData, isSrpRevamp})

    const onwardLeg = sortedFilteredCards?.[0] || []
    const returnLeg = sortedFilteredCards?.[1] || []
    const { ow: isCheckInBaggageEnabledOw, rt: isCheckInBaggageEnabledRt } = isCheckInBaggageEnabled(selectedFilters)

    // Progressive WOW pricing — fires batches of 10 after the first 100 as the
    // user scrolls. Use the SAME card list TuppleRenderer renders
    // (sortedFilteredCardsNoPTC[0]) so indices and DOM nodes line up exactly.
    const progressiveWowEnabled = isProgressiveWowEnabled(
        wowPricingVariant,
        !!processedData?.isIntl,
        isUserSignedIn()
    )
    const progressiveWowCards = useMemo(() => {
        const cards = sortedFilteredCardsNoPTC?.[0] || []
        if (isSrpRevamp && !isRT) return collapseSamePriceCards(cards)
        return cards
    }, [sortedFilteredCardsNoPTC, isSrpRevamp, isRT])
    const { makeCardRef: makeWowCardRef } = useProgressiveWowPricing({
        enabled: progressiveWowEnabled && !isRT,
        cards: progressiveWowCards,
        searchData,
        processedData: {
            isIntl: !!processedData?.isIntl,
            tripType: processedData?.tripType,
            isCfw: !!processedData?.isCfw
        },
        showPerAdultPricing,
        showCheckInBaggagePriceOW: isCheckInBaggageEnabledOw,
        wowPricingVariant
    })

    const showEmiCallout = false
    const [sortOptionsList, setSortOptionsList] = useState<any[]>([[], []])
    useEffect(() => {
        const make = (index: number) => {
            const intl = !!processedData?.isIntl
            // The revamp puts domestic RT on the same rail.
            if (!intl && !(isSrpRevamp && isRT)) return []
            const rt = isRT
            const legIsOnward = index === 0
            let sortVariables: string[] = []
            if (rt) {
                sortVariables = legIsOnward
                    ? ['round_trip_price_up', 'price_up', 'duration_up', 'arrival_up', 'arrival_down', 'departure_up', 'departure_down']
                    : ['total_price_up', 'price_up', 'duration_up', 'arrival_up', 'arrival_down', 'departure_up', 'departure_down']
            } else {
                sortVariables = ['price_up', 'duration_up', 'departure_up', 'departure_down']
            }
            const titleMap: Record<string, string> = {
                round_trip_price_up: 'Roundtrip price - lowest',
                total_price_up: 'Total price - lowest',
                price_up: 'One way price - lowest',
                duration_up: 'Shortest',
                arrival_up: 'Early morning first',
                arrival_down: 'Late night first',
                departure_up: 'Early morning first',
                departure_down: 'Late night first'
            }
            const typeMap: Record<string, 'asc' | 'desc'> = {
                round_trip_price_up: 'asc',
                total_price_up: 'asc',
                price_up: 'asc',
                duration_up: 'asc',
                arrival_up: 'asc',
                arrival_down: 'desc',
                departure_up: 'asc',
                departure_down: 'desc'
            }
            const basisMap: Record<string, string> = {
                round_trip_price_up: 'round_trip_price',
                total_price_up: 'total_price',
                price_up: 'price',
                duration_up: 'duration',
                arrival_up: 'arrival',
                arrival_down: 'arrival',
                departure_up: 'depart',
                departure_down: 'depart'
            }
            return sortVariables.map(v => ({
                title: titleMap[v],
                sortType: typeMap[v],
                sortingBasis: basisMap[v],
                sortKey: v
            }))
        }
        setSortOptionsList([make(0), make(1)])
    }, [processedData?.isIntl, isRT, isSrpRevamp])

    const onSortOptionClick = (selected: SortOptionType[]) => {
        setActiveSort(selected)
    }

    useEffect(() => {
        // couponData is fetched only for RT flights
        const updateCouponCallout = async () => {
            try {
                if (
                    !isEmpty(selectedFlights) &&
                    selectedFlights.length === 2 &&
                    !isEmpty(selectedFlights[0]) &&
                    !isEmpty(selectedFlights[1])
                ) {
                    const { key, payload } = createCopunsPayload({
                        selectedFlights,
                        subTravelOptions,
                        fares,
                        specialRTFareMap,
        searchIntent,
        dataId,
        searchId,
        supercoins,
                        processedData,
                        isCheckInBaggageEnabledOw,
                        isCheckInBaggageEnabledRt,
                        onwardPtcFareType: onwardFilterPtcType,
                        returnPtcFareType: returnFilterPtcType,
                        sourceType: 'SEARCH'
                    })
                    // Never skipped for signed-in WOW users: this is the only source of RT NEP pricing.
                    if (isEmpty(couponData[key])) {
                        setIsCouponApiLoading(true)
                        const response = await getRTFlightCouponsData(payload, processedData.isCfw)
                        const { coupons = {} } = response
                        if (!isEmpty(coupons)) {
                            dispatch(setCouponsData(coupons))
                        }
                    }
                }
            } catch (e) {
                console.log(e)
            }
            setIsCouponApiLoading(false)
        }
        updateCouponCallout()
    }, [selectedFlights])

    // Fire RT WOW fetch when BOTH legs are selected — MasterTupple needs
    // wowFares keyed by combined `[onwardFareId, returnFareId]`, which the
    // initial top-100 SRP fetch doesn't return for arbitrary combinations.
    //
    // Debounced (300ms) because the auto-select effect in TuppleRenderer
    // depends on JSON.stringify(sortedFilteredCards) and can re-fire several
    // times during initial load — each pass potentially picks a different
    // `travelOptionId`, which would otherwise trigger N back-to-back WOW
    // fetches with different payloads (each one bypassing the module-level
    // dedup since the cards differ). The debounce ensures only the FINAL
    // settled selection actually issues a request.
    const j1SelectedId = selectedFlights?.[0]?.travelOptionId
    const j2SelectedId = selectedFlights?.[1]?.travelOptionId
    const rtWowDebounceRef = useRef<ReturnType<typeof setTimeout> | null>(null)
    const rtWowRequestIdRef = useRef(0)
    useEffect(() => {
        if (rtWowDebounceRef.current) {
            clearTimeout(rtWowDebounceRef.current)
            rtWowDebounceRef.current = null
        }
        if (!isRT) return
        if (!j1SelectedId || !j2SelectedId) return
        if (!wowPricingEnabled) return
        if (!isUserSignedIn()) return
        rtWowDebounceRef.current = setTimeout(async () => {
            const wowKey = `rt:${searchData?.dataId || ''}:${j1SelectedId}|${j2SelectedId}`
            let requestId = 0
            try {
                if (!isUserSignedIn()) return
                if (wowFetchedKeysRef.current.has(wowKey)) return
                wowFetchedKeysRef.current.add(wowKey)
                requestId = ++rtWowRequestIdRef.current
                if (isSrpRevamp) {
                    dispatch(addWowLoadingFareIds([RT_MASTER_WOW_LOADING_ID]))
                }
                const selectedCards = {
                    J1: [selectedFlights[0]],
                    J2: [selectedFlights[1]]
                }
                const payload = getFetchContentPayload(
                    searchData,
                    {
                        isIntl: !!processedData?.isIntl,
                        tripType: 'roundtrip',
                        isCfw: !!processedData?.isCfw,
                        isInterstitial: false,
                        wowPricingVariant
                    },
                    selectedCards
                )
                const wowResponse = (await getWowPricingSrpData(
                    payload,
                    !!processedData?.isCfw
                )) as any
                const responseBody = wowResponse?.data ?? wowResponse ?? {}
                if (responseBody?.fares && !isEmpty(responseBody.fares)) {
                    dispatch(updateFaresPricing({
                        faresPricingData: responseBody.fares,
                        wowSorting: responseBody.wowSorting,
                        highRpsTravelOptionIds: responseBody.highRpsTravelOptionIds
                    }))
                    if (isSrpRevamp) {
                        if (requestId === rtWowRequestIdRef.current) {
                            dispatch(removeWowLoadingFareIds([RT_MASTER_WOW_LOADING_ID]))
                        }
                    }
                } else if (isSrpRevamp) {
                    wowFetchedKeysRef.current.delete(wowKey)
                    if (requestId === rtWowRequestIdRef.current) {
                        dispatch(removeWowLoadingFareIds([RT_MASTER_WOW_LOADING_ID]))
                    }
                }
            } catch (e) {
                console.error('RT WOW fetch (both legs selected) failed:', e)
                if (isSrpRevamp) {
                    wowFetchedKeysRef.current.delete(wowKey)
                    if (requestId && requestId === rtWowRequestIdRef.current) {
                        dispatch(removeWowLoadingFareIds([RT_MASTER_WOW_LOADING_ID]))
                    }
                }
            }
        }, 300)
        return () => {
            if (rtWowDebounceRef.current) {
                clearTimeout(rtWowDebounceRef.current)
                rtWowDebounceRef.current = null
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [j1SelectedId, j2SelectedId, isRT, isSrpRevamp])

    const searchFlights = async newQuery => {
        try {
            let searchQuery = processedData
            if (!isEmpty(newQuery)) {
                searchQuery = processQueryParams(router, newQuery)
            }
            setIsSeachApiLoading(true)
            const { departDate, returnDate = '' } = searchQuery
            const today = startOfDay(new Date())
            const currentDepartDate = parseDate(departDate, 'dd/MM/yyyy', new Date())
            let diffWithCurrentDepartDate = differenceInDays(currentDepartDate, today)
            if (diffWithCurrentDepartDate < 0) {
                dispatch(setError(DATE_ERROR))
                setIsSeachApiLoading(false)
                return
            }

            if (!isEmpty(returnDate)) {
                const currentArrivalDate = parseDate(returnDate, 'dd/MM/yyyy', new Date())
                let diffWithCurrentArrivalDate = differenceInDays(currentArrivalDate, today)
                if (diffWithCurrentArrivalDate < 0) {
                    dispatch(setError(DATE_ERROR))
                    setIsSeachApiLoading(false)
                    return
                }
            }
            // Reset both filter states for new search
            dispatch(setSelectedFilters({}))
            setOriginalFilterData({})
            setIsNonStopDefaultApplied(false)
            // Fresh search → clear the WOW dedup set so the new dataId can fetch.
            wowFetchedKeysRef.current = new Set()
            wowImpressionFiredRef.current = false // Re-arm a_wow_impression for the new search
            if(processedData?.isIntl && isRT) setActiveSort([
                { title: 'roundtrip price', sortType: 'asc', sortingBasis: 'round_trip_price', sortKey: 'round_trip_price_up' },
                { title: 'total price', sortType: 'asc', sortingBasis: 'total_price', sortKey: 'total_price_up' }
            ])
            else {
                setActiveSort([
                    { title: 'Cheapest', sortType: 'asc', sortingBasis: 'price', sortKey: 'price_up' },
                    { title: 'Cheapest', sortType: 'asc', sortingBasis: 'price', sortKey: 'price_up' }
                ])
            }
            const query = searchQueryUrl(searchQuery, wowPricingVariant)
            const response = (await getSearchResult(query)) as any
            dispatch(setSrpSearchData({ response }))
            setIsSeachApiLoading(false)
            // Fire WOW pricing fetch after the main SRP response — it depends
            // on `cards`, `fares`, `subTravelOptions`, `flights` from search.
            //
            // SKIP for round trip: the initial top-100 fetch returns wowFares
            // keyed by individual fareIds, but RT WOW needs COMBINED
            // `[onwardFareId, returnFareId]` keys. Those only land via the
            // separate effect that fires once the user selects both legs.
            // Firing this here just wastes a network call.
            try {
                const isRoundTripFlow = !!searchQuery.returnDate
                if (isRoundTripFlow) {
                    // For RT, clear the in-flight flag so any WowFareCallout
                    // rendered before the user makes a selection doesn't sit
                    // on the shimmer forever (initial state is `true`).
                    dispatch(setDynamicContentLoading(false))
                    return
                }
                if (wowPricingEnabled && isUserSignedIn() && response?.cards) {
                    // De-duplicate by dataId — guards against double effects.
                    const wowKey = `initial:${response?.dataId || ''}`
                    if (wowFetchedKeysRef.current.has(wowKey)) {
                        // Already fetched for this dataId — skip.
                        return
                    }
                    wowFetchedKeysRef.current.add(wowKey)
                    dispatch(setDynamicContentLoading(true))
                    const payload = getFetchContentPayload(response, {
                        isIntl: !!searchQuery.isIntl,
                        tripType: 'oneway',
                        isCfw: !!searchQuery.isCfw,
                        isInterstitial: false,
                        wowPricingVariant
                    })
                    const wowResponse = (await getWowPricingSrpData(
                        payload,
                        !!searchQuery.isCfw
                    )) as any
                    // Desktop's baseFetch returns the parsed JSON body directly
                    // (no axios `.data` envelope), so destructure the top level.
                    // Backend may still wrap fares in `data` — handle both shapes.
                    const wowBody = wowResponse?.data ?? wowResponse ?? {}
                    const {
                        fares: faresPricingData,
                        wowSorting,
                        highRpsTravelOptionIds
                    } = wowBody
                    dispatch(
                        updateFaresPricing({
                            faresPricingData,
                            wowSorting,
                            highRpsTravelOptionIds
                        })
                    )
                } else {
                    dispatch(setDynamicContentLoading(false))
                }
            } catch (wowErr) {
                console.error('WOW pricing fetch failed:', wowErr)
                dispatch(setDynamicContentLoading(false))
            }
        } catch (e: any) {
            dispatch(setSrpSearchData({ response: { statusCode: e?.errorCode ?? null } }))
            setIsSeachApiLoading(false)
        }
    }

    const airportSearch = async () => {
        try {
            let urlParams = router.query as unknown as QueryParamsData
            let payload = [processedData?.source, processedData?.destination]
            let response = await airportSearchBluk(payload) as any
            const { data, code } = response
            console.log(data, code, 'airportv3')
            if (data && code === 200) {
                // Store the full response data for country code extraction
                setAirportSearchBlukResponse(data)
                
                let departIntl = formAirportList(data, processedData?.source)
                let arrivalIntl = formAirportList(data, processedData?.destination)
                setPlacesSearch({
                    api: true,
                    departKey: departIntl.label,
                    arrivalKey: arrivalIntl.label
                })
                urlParams.origin = departIntl.label
                urlParams.destination = arrivalIntl.label
                // Preserve isCfw from processedData
                urlParams.isCfw = processedData.isCfw
                urlParams.sft = processedData.sft
                setSearchQuery(urlParams)
            } else {
                setPlacesSearch({
                    api: false
                })
            }
        } catch (e) {
            console.log(e)
        }
    }

    // Visa Denial Eligibility API Call for SRP using Redux - Call only once per unique search
    useEffect(() => {
        // Skip if required props are not available. Sector type (domestic vs
        // international) is decided later from the airportSearchBluk country codes,
        // NOT from processedData.isIntl — that route-derived flag goes stale when
        // the user changes the to/from airports.
        if (!processedData?.source || !processedData?.destination || !processedData?.departDate) {
            return
        }

        // For round trip, also check return date
        if (processedData?.tripType === 'roundtrip' && !processedData?.returnDate) {
            return
        }

        // Create a unique key for this search combination
        const searchKey = `${processedData.source}-${processedData.destination}-${processedData.departDate}-${processedData.returnDate || ''}-${processedData.tripType}`
        
        // Skip if we've already made the call for this exact search
        // The check inside checkVisaDenialEligibility will handle marking as done only when airportSearchBlukResponse is available
        if (lastVisaDenialParamsRef.current === searchKey) {
            return
        }

        const checkVisaDenialEligibility = () => {
            // Only proceed if we have airportSearchBlukResponse or metaData for country code extraction
            // This ensures we wait for country code data before making the API call
            // Priority: Wait for airportSearchBlukResponse if possible, fallback to metaData
            if (!airportSearchBlukResponse && !metaData) {
                return
            }

            // vasDiscovery is only relevant for international sectors. Decide from
            // the authoritative airport country codes so a domestic search never
            // triggers the call, even if the stale route flag still says intl.
            const isInternational = isInternationalSector(
                airportSearchBlukResponse,
                processedData?.source || '',
                processedData?.destination || '',
                !!processedData?.isIntl
            )
            if (!isInternational) {
                // Domestic sector — clear any stale visa-denial result so the
                // banner from a previous international search goes away.
                dispatch(resetVisaDenialState())
                return
            }

            // Create visa denial payload using helper function
            const payload = createVisaDenialPayload({
                source: processedData?.source || '',
                destination: processedData?.destination || '',
                departDate: processedData?.departDate || '',
                returnDate: processedData?.returnDate,
                tripType: processedData?.tripType === 'roundtrip' ? 'ROUNDTRIP' : 'ONEWAY',
                isIntl: processedData?.isIntl || false,
                isCfw: processedData?.isCfw || false,
                airportSearchBlukResponse: airportSearchBlukResponse,
                metaData: metaData
            })

            if (payload) {
                // Mark that we've made the call for this search
                // Always set the ref when we dispatch to prevent duplicate calls
                lastVisaDenialParamsRef.current = searchKey

                // Dispatch Redux action
                dispatch(fetchVisaDenialEligibilityData(payload))
            }
        }

        // Clear any existing timeout
        if (visaDenialTimeoutRef.current) {
            clearTimeout(visaDenialTimeoutRef.current)
        }

        // Use debounce with 500ms delay
        visaDenialTimeoutRef.current = setTimeout(() => {
            checkVisaDenialEligibility()
            visaDenialTimeoutRef.current = null
        }, 500)

        // Cleanup function
        return () => {
            if (visaDenialTimeoutRef.current) {
                clearTimeout(visaDenialTimeoutRef.current)
                visaDenialTimeoutRef.current = null
            }
        }
    }, [
        processedData?.isIntl,
        processedData?.tripType,
        processedData?.departDate,
        processedData?.returnDate,
        processedData?.source,
        processedData?.destination,
        metaData,
        dispatch,
        airportSearchBlukResponse
    ])

    const getUnselectedFiltersObj = (originalLegData: any) => {
        const nearbyAirportFilter = originalLegData?.nearbyAirportFilter || []
        return {
            stops: {
                ...(originalLegData?.stops || {}),
                selectedValues: []
            },
            ptcFare: {
                enabled: originalLegData?.ptcFare || false,
                checked: false
            },
            airlineFilter: {
                ...(originalLegData?.airlineFilter || {}),
                selectedValues: []
            },
            departureTimeFrom: [
                { ...(originalLegData?.departureTimeFrom?.[0] || {}), selectedValues: [] },
                { ...(originalLegData?.departureTimeFrom?.[1] || {}), selectedValues: [] }
            ],
            arrivalTimeFrom: [
                { ...(originalLegData?.arrivalTimeFrom?.[0] || {}), selectedValues: [] },
                { ...(originalLegData?.arrivalTimeFrom?.[1] || {}), selectedValues: [] }
            ],
            nearbyAirportFilter:
                nearbyAirportFilter.length > 1
                    ? [
                          { ...(originalLegData?.nearbyAirportFilter?.[0] || {}), selectedValues: [] },
                          { ...(originalLegData?.nearbyAirportFilter?.[1] || {}), selectedValues: [] }
                      ]
                    : nearbyAirportFilter.length > 0
                    ? [{ ...(originalLegData?.nearbyAirportFilter?.[0] || {}), selectedValues: [] }]
                    : [],
            layoverDuration: {
                 ...originalLegData?.layoverDuration,
                 current: { 
                     min: originalLegData?.layoverDuration?.min, 
                     max: originalLegData?.layoverDuration?.max 
                 } 
             },
            tripDuration: {
                 ...originalLegData?.tripDuration,
                 current: { 
                     min: originalLegData?.tripDuration?.min, 
                     max: originalLegData?.tripDuration?.max 
                 } 
            },
            oneWayPrice: {
                ...originalLegData?.oneWayPrice,
                current: originalLegData?.oneWayPrice?.current
            },
            fareInclusions: {
                ...(originalLegData?.fareInclusions || {}),
                selectedValues: []
            },
            layoverAirport: {
                ...originalLegData?.layoverAirport,
                selectedOptions: {}
            }
        }
    }

    const createResetFilterData = (sourceData: any) => {
        const clearedOnwardFilters = getUnselectedFiltersObj(sourceData?.onwardLeg || {})
        const clearedReturnFilters = getUnselectedFiltersObj(sourceData?.returnLeg || {})
        
        return {
            ...sourceData,
            onwardLeg: {
                ...clearedOnwardFilters,
                ctUpgrade: sourceData?.onwardLeg?.ctUpgrade,
                visaRejection: sourceData?.onwardLeg?.visaRejection
            },
            returnLeg: {
                ...clearedReturnFilters,
                ctUpgrade: sourceData?.returnLeg?.ctUpgrade,
                visaRejection: sourceData?.returnLeg?.visaRejection
            },
            ctUpgrade: {
                enabled: sourceData?.onwardLeg?.ctUpgrade || sourceData?.returnLeg?.ctUpgrade,
                checked: false
            },
            visaRejection: {
                enabled: sourceData?.onwardLeg?.visaRejection || sourceData?.returnLeg?.visaRejection,
                checked: false
            },
            totalRoundTripPrice: {
                ...sourceData?.totalRoundTripPrice,
                current: sourceData?.totalRoundTripPrice?.current || sourceData?.totalRoundTripPrice?.min
            }
        }
    }

    const validateJourneyFilters = (preAppliedFilters: any, sourceFilters: any) => {
        const { ptcFare = false } = sourceFilters || {}
        return {
            ...preAppliedFilters,
            ptcFare: {
                enabled: isEmpty(ptcFare) ? false : ptcFare,
                checked: ptcFare ? preAppliedFilters?.ptcFare?.checked : false
            }
        }
    }

    const validateFilters = (preAppliedFilters: any) => {
        const { onwardLeg, returnLeg } = filterData
        const { onwardLeg: preAppliedOnwardFilters, returnLeg: preAppliedReturnFilters } = preAppliedFilters
        const onwardFilters = validateJourneyFilters(preAppliedOnwardFilters, onwardLeg)
        const returnFilters = validateJourneyFilters(preAppliedReturnFilters, returnLeg)
        return {
            ...preAppliedFilters,
            onwardLeg: {
                ...onwardFilters,
            },
            returnLeg: {
                ...returnFilters,
            }
        }
    }

    const getPreAppliedFilters = (sanitizedFilterData?: any) => {
        let preAppliedFilterData = window.sessionStorage?.getItem('savedFilters') || ''
        const isNonStopDefaultSectorValue = isNonStopDefaultSector()
        
        // If no saved filters and not a non-stop default sector, return empty
        if (isEmpty(preAppliedFilterData) && !isNonStopDefaultSectorValue) {
            return {}
        }
        
        // Parse saved filters if they exist
        const { queryData, filterData: preAppliedFilters = {} } = 
            isEmpty(preAppliedFilterData) ? {} : JSON.parse(preAppliedFilterData) || {}
        
        // Validate saved filters have proper structure
        if (!isEmpty(preAppliedFilterData) && isEmpty(preAppliedFilters?.onwardLeg?.stops?.options)) {
            window.sessionStorage?.removeItem('savedFilters')
            // If it's a non-stop default sector, apply the filter
            if (isNonStopDefaultSectorValue && sanitizedFilterData) {
                setIsNonStopDefaultApplied(true)
                return applyNonStopDefaultFilter(sanitizedFilterData)
            }
            return {}
        }

        // If saved filters match current query, use them
        if (deepEqual(queryDataForFilters, queryData)) {
            return validateFilters(preAppliedFilters)
        } 
        // If it's a non-stop default sector and no matching saved filters
        else if (isNonStopDefaultSectorValue && sanitizedFilterData) {
            window.sessionStorage?.removeItem('savedFilters')
            setIsNonStopDefaultApplied(true)
            return applyNonStopDefaultFilter(sanitizedFilterData)
        }
        // Otherwise, clear saved filters
        else {
            window.sessionStorage?.removeItem('savedFilters')
            return {}
        }
    }

    const setFilterData = (filterData: Record<string, any>) => {
        const finalFilterData = {  
            ...filterData,
            ctUpgrade: {
                enabled: !!filterData?.ctUpgrade?.enabled,
                checked: filterData?.ctUpgrade?.checked || false 
            }
        }
        
        dispatch(setSelectedFilters(finalFilterData))
        if (!isServer()) {
            window.sessionStorage.setItem(
                'savedFilters',
                JSON.stringify({
                    filterData: finalFilterData,
                    queryData: queryDataForFilters
                })
            )
        }
    }

    const updateFilterData = (updater: (prevState: any) => any) => {
        const newFilterData = updater(selectedFilters)
        setFilterData(newFilterData)
    }

    const clearFiltersCategoryWise = (filterData: FilterData, isRT : boolean, filterType: string) => {
        const onwardLegFilters = filterData?.onwardLeg || {};
        const returnCurrentLegFilters = filterData?.returnLeg || {};
        const originalOnwardData = originalFilterData?.onwardLeg || {}
        const originalReturnData = originalFilterData?.returnLeg || {}
        
        // Handle root-level filters (visaRejection, ctUpgrade)
        if (filterType === 'visaRejection' || filterType === 'ctUpgrade') {
            const updatedData = {
                ...filterData,
                [filterType]: {
                    enabled: false,
                    checked: false
                }
            };
            setFilterData(updatedData)
            return
        }
        
        const getResetValue = (currentFilters: any, originalData: any) => {
            switch (filterType) {
                case filterTypes.PTC_FARE:
                    return {
                        ...(currentFilters[filterType] || {}),
                        checked: false
                    }
                case 'nearbyAirportFilter':
                    const nearbyAirportFilter = originalData?.nearbyAirportFilter || []
                    return nearbyAirportFilter.length > 1
                        ? [
                              { ...(originalData?.nearbyAirportFilter?.[0] || {}), selectedValues: [] },
                              { ...(originalData?.nearbyAirportFilter?.[1] || {}), selectedValues: [] }
                          ]
                        : nearbyAirportFilter.length > 0
                        ? [{ ...(originalData?.nearbyAirportFilter?.[0] || {}), selectedValues: [] }]
                        : []
                case 'airlineFilter':
                case 'stops':
                    return {
                        ...(currentFilters[filterType] || {}),
                        selectedValues: []
                    }
                case 'departureTimeFrom':
                case 'arrivalTimeFrom':
                    return [
                        { ...(originalData?.[filterType]?.[0] || {}), selectedValues: [] },
                        { ...(originalData?.[filterType]?.[1] || {}), selectedValues: [] }
                    ]
                case 'oneWayPrice':
                    return {
                        ...(currentFilters[filterType] || {}),
                        current: originalData?.[filterType]?.current || originalData?.[filterType]?.min,
                        currentADT: originalData?.[filterType]?.currentADT ?? originalData?.[filterType]?.maxADT
                    }
                case 'tripDuration':
                case 'layoverDuration':
                    return {
                        ...(currentFilters[filterType] || {}),
                        current: { 
                            min: originalData?.[filterType]?.min, 
                            max: originalData?.[filterType]?.max 
                        }
                    }
                case 'checkInBaggage':
                    return {
                        ...(currentFilters['fareInclusions'] || {}),
                        selectedValues: []
                    }
                case 'layoverAirport':
                    return {
                        ...(currentFilters[filterType] || {}),
                        selectedOptions: {}
                    }
                default:
                    return {
                        ...(currentFilters[filterType] || {}),
                        selectedValues: []
                    }
            }
        }
        
        const updatedData = {
            ...filterData,
            ['onwardLeg']: {
                ...onwardLegFilters,
                [filterType === 'checkInBaggage' ? 'fareInclusions' : filterType]: getResetValue(onwardLegFilters, originalOnwardData)
            }
        };
        
        // Only clear return leg if it's a round trip
        if (isRT) {
            updatedData['returnLeg'] = {
                ...returnCurrentLegFilters,
                [filterType === 'checkInBaggage' ? 'fareInclusions' : filterType]: getResetValue(returnCurrentLegFilters, originalReturnData)
            };
        }
        
        setFilterData(updatedData)
    }

    const resetDurationFilters = (filterData: FilterData) => {
      const onwardLegFilters = filterData?.onwardLeg || {}
      const returnLegFilters = filterData?.returnLeg || {}
      const originalOnwardData = originalFilterData?.onwardLeg || {}
      const originalReturnData = originalFilterData?.returnLeg || {}

      const updatedData = {
        ...filterData,
        onwardLeg: {
          ...onwardLegFilters,
          layoverDuration: {
            ...originalOnwardData?.layoverDuration,
            current: {
              min: originalOnwardData?.layoverDuration?.min,
              max: originalOnwardData?.layoverDuration?.max,
            },
          },
          tripDuration: {
            ...originalOnwardData?.tripDuration,
            current: {
              min: originalOnwardData?.tripDuration?.min,
              max: originalOnwardData?.tripDuration?.max,
            },
          },
        },
        returnLeg: {
          ...returnLegFilters,
          layoverDuration: {
            ...originalReturnData?.layoverDuration,
            current: {
              min: originalReturnData?.layoverDuration?.min,
              max: originalReturnData?.layoverDuration?.max,
            },
          },
          tripDuration: {
            ...originalReturnData?.tripDuration,
            current: {
              min: originalReturnData?.tripDuration?.min,
              max: originalReturnData?.tripDuration?.max,
            },
          },
        },
      }
      setFilterData(updatedData)
    }

    const resetTimingsFilters = (filterData: FilterData) => {
        const onwardLegFilters = filterData?.onwardLeg || {}
        const returnLegFilters = filterData?.returnLeg || {}
        const originalOnwardData = originalFilterData?.onwardLeg || {}
        const originalReturnData = originalFilterData?.returnLeg || {}
  
        const updatedData = {
          ...filterData,
          onwardLeg: {
            ...onwardLegFilters,
            departureTimeFrom: [
                { ...(originalOnwardData?.departureTimeFrom?.[0] || {}), selectedValues: [] },
                { ...(originalOnwardData?.departureTimeFrom?.[1] || {}), selectedValues: [] }
            ],
            arrivalTimeFrom: [
                { ...(originalOnwardData?.arrivalTimeFrom?.[0] || {}), selectedValues: [] },
                { ...(originalOnwardData?.arrivalTimeFrom?.[1] || {}), selectedValues: [] }
            ]
          },
          returnLeg: {
            ...returnLegFilters,
            departureTimeFrom: [
                { ...(originalReturnData?.departureTimeFrom?.[0] || {}), selectedValues: [] },
                { ...(originalReturnData?.departureTimeFrom?.[1] || {}), selectedValues: [] }
            ],
            arrivalTimeFrom: [
                { ...(originalReturnData?.arrivalTimeFrom?.[0] || {}), selectedValues: [] },
                { ...(originalReturnData?.arrivalTimeFrom?.[1] || {}), selectedValues: [] }
            ]
          },
        }
        setFilterData(updatedData)
      }

    const resetFilters = () => {
        const resetFilterData = createResetFilterData(originalFilterData)
        setFilterData(resetFilterData)
        ravenSDKSrpCfwTrigger('a_ui_action', searchData, processedData, {
            action_name:'reset_filter_click',
            action_type: 'click',
            property: 'srp_page',
        })
    }

    const sendSentryMetrics = (
      eventName: CountMetricName,
      count: number,
      sendAttributes?: boolean,
      additionalAttributes?: Record<string, string | number>
    ) => {
      try {
        if (sendAttributes) {
          const attributes = {
            origin: processedData?.source || 'N/A',
            destination: processedData?.destination || 'N/A',
            depart_date: processedData?.departDate || 'N/A',
            return_date: processedData?.returnDate || 'N/A',
            adult_count: processedData?.travellers?.adults || 'N/A',
            child_count: processedData?.travellers?.children || 'N/A',
            infant_count: processedData?.travellers?.infants || 'N/A',
            trip_type: processedData?.tripType || 'N/A',
            flight_class: processedData?.flightClass || 'N/A',
            dx: processedData?.dx || 'N/A',
            ...getSrpMetricAttributes(processedData),
            ...additionalAttributes,
          }
          countMetric(eventName, count, attributes)
        } else {
          countMetric(eventName, count)
        }
      } catch (error) {
        console.error('Error sending sentry metrics:', error)
      }
    }

    useEffect(() => {
        storeUtmParams()
        let query = router.query as unknown as QueryParamsData
        // Preserve isCfw from processedData when setting searchQuery
        setSearchQuery({ ...query, isCfw: processedData.isCfw, sft: processedData.sft })
        sendSentryMetrics(FUNNEL_SRP_STARTED, 1)
        ;(async function () {
            const { registerUser, utmCustom } = getCollectionRegisterationInfo()
            if (registerUser) {
                registerUserToCollection({ utmPaid: utmCustom })
            }
            await Promise.all([airportSearch(), searchFlights()])
        })()

        // Load offerSlot.js so window.offerJson is available for C2P sector gate.
        const loadOfferSlot = () => {
            if ((window as any).offerJson) return // already loaded by HomeMain/HomeHeader
            const env =
                process.env.NEXT_PUBLIC_CT_ENV === 'production' || process.env.NEXT_PUBLIC_CT_ENV === 'beta'
                    ? 'prod'
                    : 'staging'
            const cleartripScriptOrigin = getCleartripScriptOrigin()
            getScript(
                `${cleartripScriptOrigin}/offermgmt/offermgmt/offerJson/${env}/offerSlot.js?` + new Date().getTime(),
                () => {} // window.offerJson is now set; C2P sector reads it at click time
            )
        }

        if (document.readyState === 'complete') {
            loadOfferSlot()
        } else {
            window.addEventListener('load', loadOfferSlot)
            return () => window.removeEventListener('load', loadOfferSlot)
        }
    }, [])


    useEffect(() => {
        if (!isStoreDataLoading && !isSearchApiLoading && isEmpty(selectedFilters)) {
            setRumPage('flights_srp')
            // Store original filter data (immutable copy from API response)
            if (!isEmpty(filterData) && isEmpty(originalFilterData)) {
                setOriginalFilterData(JSON.parse(JSON.stringify(filterData))) // Deep copy to prevent mutation
            }
            const { onwardLeg, returnLeg } = filterData || {}
            const { ptcFare: onwardPtcFare = false } = onwardLeg || {}
            const { ptcFare: returnPtcFare = false } = returnLeg || {}
            const isIntlStudentFare = isIntl && processedData?.sft === 'student' && (onwardPtcFare || returnPtcFare)
            if (isIntlStudentFare) {
                setToastMsg(STUDENT_FARE_TOAST_MESSAGE)
            }
            // Create sanitized filter data for non-stop default logic
            const resetFilterData = createResetFilterData(filterData)
            const sanitizedFilterData = {
                ...resetFilterData
                // Preserve ctUpgrade as-is from API response (determines visibility and default state)
            }
            
            const preAppliedFilters = getPreAppliedFilters(sanitizedFilterData)
            const isMultiFare = processedData?.isMultiFare
            if (!isEmpty(preAppliedFilters)) {
                setFilterData(preAppliedFilters)
            } else {
                setFilterData(resetFilterData)
            }
            let isEmptyResult = false
            if (isEmpty(srpError) && (isEmpty(cards) || isEmpty(cards.J1) || (isRT && isEmpty(cards.J2)))) {
                isEmptyResult = true
                sendSentryMetrics(API_SRP_ERROR, 1, true, {
                    error_type: SEARCH_NO_FLIGHTS_AVAILABLE,
                    responseStatus: responseStatusCode || 'N/A',
                    source: 'srpContainer',
                })
                const failedLeg = processedData.returnDate
                    ? (!cards?.J1?.length && !cards?.J2?.length ? 'BOTH' : !cards?.J1?.length ? 'J1' : 'J2')
                    : null
                trackRumEvent(RUM_EVENT.SEARCH_RESULTS_EMPTY, { ...srpContext, failedLeg })
                dispatch(setError(SEARCH_NO_FLIGHTS_AVAILABLE))
            }
            if (srpError) {
                ravenSDKSrpCfwTrigger(RAVEN_EVENT_NAME.SRP_FAILURE, searchData, processedData, {
                    a_failure_reason: srpError,
                    page_loadtime: new Date().getTime() - initialTS || 'N/A'
                })
                sendSentryMetrics(API_SRP_ERROR, 1, true, {
                    error_type: srpError,
                    responseStatus: responseStatusCode || 'N/A',
                    source: 'srpContainer',
                })
                const httpStatus = Number(responseStatusCode) || null
                if (srpError === SEARCH_NO_FLIGHTS_AVAILABLE) {
                    const failedLeg = processedData.returnDate
                        ? (!cards?.J1?.length && !cards?.J2?.length ? 'BOTH' : !cards?.J1?.length ? 'J1' : 'J2')
                        : null
                    trackRumEvent(RUM_EVENT.SEARCH_RESULTS_EMPTY, { ...srpContext, failedLeg })
                } else {
                    trackRumEvent(RUM_EVENT.SEARCH_FAILED, {
                        ...srpContext,
                        reason: srpError,
                        statusCode: httpStatus,
                        searchQuery: searchQueryUrl(processedData, wowPricingVariant),
                        latency: Date.now() - initialTS,
                    })
                }
            } else if (!isEmptyResult) {
                const originCity = metaData?.airportDetail?.[processedData?.source]?.city
                const destinationCity = metaData?.airportDetail?.[processedData?.destination]?.city
                
                const ravenPayload = {
                    page_loadtime: new Date().getTime() - initialTS || 'N/A',
                    ct_lifetime_booking: 'na',
                    ct_postmerger_booking: 'na',
                    ct_last_1year_booking: 'na',
                    fk_loyalty_status: 'na',
                    myntra_loyalty_status: 'na',
                    ct_first_booking_dt: 'na',
                    ct_last_booking_dt: 'na',
                    ct_2nd_last_booking_dt: 'na',
                    fk_loyalty_start_dt: 'na',
                    fk_loyalty_end_dt: 'na',
                    myntra_loyalty_start_dt: 'na',
                    myntra_loyalty_end_dt: 'na',
                    a_srp_ff_cookie: getFFCookieValue(),
                    is_ff_srp: isMultiFare ? 'yes' : 'no',
                    clevertap_depart_date: processedData?.departDate || 'N/A',
                    clevertap_arrival_date: processedData?.returnDate || 'N/A',
                    a_origin_city: originCity || processedData?.source || 'n/a',
                    a_destination_city: destinationCity || processedData?.destination || 'n/a'
                }
                sendSentryMetrics(FUNNEL_SRP_LOADED, 1)
                ravenSDKSrpCfwTrigger(RAVEN_EVENT_NAME.SRP_PAGELOAD, searchData, processedData, ravenPayload)
                trackRumEvent(RUM_EVENT.SEARCH_RESULTS_LOADED, {
                    ...srpContext,
                    latency: Date.now() - initialTS,
                })
            }
        }
    }, [searchData, isStoreDataLoading, filterData, originalFilterData, isSearchApiLoading])

    useEffect(() => {
        try {
            if (wowImpressionFiredRef?.current) return
            if (!wowPricingEnabled) return
            if (isStoreDataLoading || isSearchApiLoading || isEmpty(searchData) || isEmpty(cards)) return

            if (isEmpty(wowFares) && isDynamicContentLoading) return

            wowImpressionFiredRef.current = true
            const wowFare = Object.values(wowFares || {})[0] as any
            const { isUserCBCHolder = false } = wowFare?.metaData || {}
            ravenSDKSrpCfwTrigger('a_wow_impression', searchData, processedData, {
                page_name: 'flights_srp',
                page_loadtime: new Date().getTime() - initialTS || 'N/A',
                supercoin_balance: searchData?.supercoins?.balance || 0,
                ct_wallet_balance: getSrpWalletBalance(wowFare),
                a_ab_key: '',
                ab_variant: wowPricingVariant || 'N/A',
                is_cbcc_user: isUserCBCHolder
            })
        } catch (error) {
            console.error('a_wow_impression trigger failed:', error)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [wowFares, isDynamicContentLoading, isStoreDataLoading, isSearchApiLoading, searchData, cards])

    /**
     * The RT bottom bar must price the same lead fare the tuple strip shows, so it reads the
     * search snapshot rather than `searchData.subTravelOptions` — the latter is rewritten by
     * `mergeInterstitialData` once the fare-family modal has fetched.
     */
    const searchSubTravelOptions = useAppSelector(getSearchSubTravelOptions)
    const masterTuppleSubTravelOptions = !isEmpty(searchSubTravelOptions)
        ? searchSubTravelOptions
        : subTravelOptions
    const masterTuppleData = useMemo(
        () =>
            getMasterTuppleProps({
                selectedFlights,
                metaData,
                subTravelOptions: masterTuppleSubTravelOptions,
                fares,
                showPerAdultPricing,
                specialRTFareMap,
                isCheckInBaggageEnabledOw,
                isCheckInBaggageEnabledRt,
                onwardPtcFareType: onwardFilterPtcType,
                returnPtcFareType: returnFilterPtcType
            }),
        [selectedFlights, masterTuppleSubTravelOptions]
    )

    const resetSearch = query => {
        trackRumEvent(RUM_EVENT.SEARCH_MODIFIED, srpContext)
        const pd = processQueryParams(router, query)
        const normalizedQuery = { ...query, sft: pd.sft, isCfw: pd.isCfw }
        setSearchQuery(normalizedQuery)
        pushSearchQueryUrl(normalizedQuery)
        searchFlights(query)
        ravenSDKSrpCfwTrigger(RAVEN_EVENT_NAME.SRP_SEARCH_CLICK, searchData, processedData, {})
    }

    useEffect(() => {
        if (toastMsg) {
            toastTimer.current = setTimeout(() => setToastMsg(""), 4000)
        }

        return () => clearTimeout(toastTimer.current)
    }, [toastMsg])

    const isPtcFareAvailable = isRT
        ? isOnwardPtcFareAvailable && isReturnPtcFareAvailable
        : isOnwardPtcFareAvailable
    const revampPtcStripType = resolveRevampPtcStripType(sftFareType, ptcAvailability)
    // Revamp coupons scroller already pads 16px below the cards (shadow room), so 8px more makes the 24px gap.
    const couponsBarSpacerClassName = isSrpRevamp ? 'mb-2' : 'mb-6'
    const showStudentFareStrip =
        !isSearchApiLoading &&
        (isSrpRevamp ? !!revampPtcStripType : showStudentFareQuickFilter && isPtcFareAvailable)
    const studentFilterProps: StudentFareFilterProps = {
        isRT,
        selectedFilters,
        updateFilterData,
        isIntl,
        ptcType: (isSrpRevamp && revampPtcStripType) || 'student',
    }
    const showPeThemeChrome = showPeSrpHero && isSrpThemeCabin(searchQuery?.class)
    // TuppleRenderer selects from these lists, so a leg with cards only looks unselected until that runs.
    const legHasFlights: [boolean, boolean] = [!isEmpty(sortedFilteredCardsNoPTC?.[0]), !isEmpty(sortedFilteredCardsNoPTC?.[1])]

    const isLegacyFF = fareType === 'FF' && !isSrpRevamp
    const searchBandCss = isSrpRevamp ? { boxShadow: SRP_REVAMP_BAND_SHADOW } : undefined
    const searchBandStyle = isLegacyFF ? { scale: '0.90', margin: '-8px -96px 0px -96px' } : undefined
    const shellClassName = isSrpRevamp ? 'px-7' : ''
    const searchShellCss = isSrpRevamp ? SRP_REVAMP_SHELL_CSS : undefined

    let legacyShellMaxWidth = '1264px'
    if (fareType === 'FF') legacyShellMaxWidth = isIntl && isRT ? INTL_RT_CONTAINER_WIDTH : '1140px'
    const resultsShellClassName = isSrpRevamp ? 'pt-6 px-7' : 'pt-6'
    const resultsShellCss = isSrpRevamp ? SRP_REVAMP_SHELL_CSS : { maxWidth: legacyShellMaxWidth, margin: 'auto' }
    const resultsRowClassName = isSrpRevamp ? 'flex flex-cg-6' : 'flex'
    // Revamp RT: the row is exactly one viewport tall, so once the page scrolls to it the legs, sort bars and
    // booking bar fill the screen. Everything inside sizes by flex, so a new widget just shortens the legs.
    const resultsRowCss = isSrpRevamp && isRT && !isSearchApiLoading ? { height: '100vh' } : undefined
    // The revamp never collapses these, so skip framer's mount animation from height 0 (a load-time shift).
    const collapseInitial = isSrpRevamp ? 'open' : undefined

    // Revamp: 288 + 24 + 912 + 56 = 1280. Keep results at a fixed width so tuples
    // don't compress when the viewport (or scrollbar) is narrower than the shell.
    const legacyResultsWidth = fareType === 'FF' ? '886px' : '888px'
    const resultsColumnClassName = isLegacyFF ? 'p-relative flex flex-column mx-2' : 'p-relative flex flex-column'
    const resultsColumnCss = isSrpRevamp
        ? { width: SRP_REVAMP_RESULTS_WIDTH, minWidth: SRP_REVAMP_RESULTS_WIDTH, flexShrink: 0 }
        : { width: legacyResultsWidth }
    const masterTuppleFF =
        isRT && !isSearchApiLoading && isFareFamilyFlow ? (
            <MasterTuppleFareFamilyDomestic
                legHasFlights={legHasFlights}
                selectedFlights={selectedFlights}
                isCouponApiLoading={isCouponApiLoading}
                processedData={processedData}
                showPerAdultPricing={showPerAdultPricing}
                searchQuery={searchQuery}
                paxCriteria={paxCriteria}
                selectedFilters={selectedFilters}
                masterTuppleRef={masterTuppleRef}
                {...masterTuppleData}
                showEmi={showEmi}
                setShowEmi={setShowEmi}
                showAnimation={showAnimation}
                hasShownEmiTooltipRef={hasShownEmiTooltipRef}
                toastHandler={(msg: string) => setToastMsg(msg)}
            />
        ) : null

    return (
        <>
            {showPeThemeChrome && !srpError && (
                <Container
                    aria-hidden
                    className="p-fixed t-0 l-0 r-0 disable-pointer-events"
                    css={{
                        height: '100vh',
                        zIndex: 0,
                        background: getSrpHeroTheme(searchQuery?.class)?.scrollShade,
                    }}
                />
            )}
             <Collapse pose={collapseState} initial={collapseInitial}>
            {showPeThemeChrome ? (
                <PESrpHero fareType={fareType} cabinClass={searchQuery?.class} isSrpRevamp={isSrpRevamp}>
                    <ModifySearchWidget
                        searchQuery={searchQuery}
                        isSearchApiLoading={isSearchApiLoading}
                        searchData={searchData}
                        onSearchClick={resetSearch}
                        fareType={fareType}
                        isSrpRevamp={isSrpRevamp}
                        isThemed
                        isDarkThemed={isSrpFirstClassCabin(searchQuery?.class)}
                    />
                </PESrpHero>
            ) : (
                <Container
                    className="pb-6 pt-2 z-30 bg-white p-relative"
                    css={searchBandCss}
                    style={searchBandStyle}
                >
                    <Container className={shellClassName} css={searchShellCss}>
                        <ModifySearchWidget
                            searchQuery={searchQuery}
                            isSearchApiLoading={isSearchApiLoading}
                            searchData={searchData}
                            onSearchClick={resetSearch}
                            fareType={fareType}
                            isSrpRevamp={isSrpRevamp}
                        />
                    </Container>
                </Container>
            )}
            </Collapse>
            <Divider className="w-100p" />
            {srpError ? (
                <SearchError errorType={srpError} />
            ) : (
                <Container
                    className={resultsShellClassName}
                    css={resultsShellCss}
                >
                    <Container ref={resultsRowRef} className={resultsRowClassName} css={resultsRowCss}>
                        {isSrpRevamp && isSearchApiLoading ? (
                            <FindingFlightsLoader cabinClass={searchQuery?.class} />
                        ) : (
                            <>
                        {!isSearchApiLoading ? (
                            <Filters
                                isSrpRevamp={isSrpRevamp}
                                selectedFilters={selectedFilters}
                                updateFilterData={updateFilterData}
                                isRT={isRT}
                                totalFlightsCount={totalFlightsCount}
                                filteredFlightsCount={filteredFlightsCount}
                                onewayFilteredFlightsCount={onewayFilteredFlightsCount}
                                resetFilters={resetFilters}
                                clearFiltersCategoryWise={clearFiltersCategoryWise}
                                resetDurationFilters={resetDurationFilters}
                                resetTimingsFilters={resetTimingsFilters}
                                processedData={processedData}
                                setSelectedPrice={setSelectedPrice}
                                filterData={!isEmpty(originalFilterData) ? originalFilterData : filterData} // Use original data if available
                                isIntl={isIntl}
                                updatedReturnListLength={updatedReturnListLength}
                                masterTuppleRef={masterTuppleRef}
                                isNonStopDefaultApplied={isNonStopDefaultApplied}
                                onNonStopTooltipDismiss={handleNonStopTooltipDismiss}
                            />
                        ) : (
                            /* Legacy only — the revamp short-circuits the whole row to its own loader. */
                            <Container className="h-100p" css={LEGACY_FILTER_RAIL_CSS}>
                                <FiltersLoader />
                            </Container>
                        )}
                        {fareType !== 'FF' && !isSrpRevamp && <Spacer className="ml-12" />}
                        <Container
                            className={resultsColumnClassName}
                            css={resultsColumnCss}
                        >
                            { !isEmpty(srpCouponList) && !(isSrpRevamp && !isRT) ? (
                                <Collapse pose={showPeThemeChrome ? collapseState : 'open'} initial={collapseInitial}>
                                    <SrpCouponsBar isRevamp={isSrpRevamp} srpCouponList={srpCouponList} />
                                    <Spacer className={couponsBarSpacerClassName} />
                                </Collapse>
                            ) : (
                                ''
                            )}
                            {!isSrpRevamp && masterTuppleFF}
                             
                            {!(isSrpRevamp && isRT) && <DateSelectorWrapper
                                isLoading={isSearchApiLoading}
                                isRT={isRT}
                                searchQuery={searchQuery}
                                resetSearch={resetSearch}
                                toastHandler={(msg: string) => setToastMsg(msg)}
                                showOnwardPriceTooltip={cards?.J1?.length !== sortedFilteredCards?.[0]?.length}
                                showReturnPriceTooltip={isRT && cards?.J2?.length !== sortedFilteredCards?.[1]?.length}
                                sortedFilteredCards={sortedFilteredCards}
                                isSrpRevamp={isSrpRevamp}
                            />}
                                {!isIntl && !isSrpRevamp && sftFareType && !isSearchApiLoading && 
                                    <Container>
                                        <PtcFareTopCallout query={searchQuery} />
                            </Container>}
                            <Collapse pose={collapseState} initial={collapseInitial}>
                            {processedData?.isIntl && showEmiCallout && 
                            <EmiCallout showEmi={showEmi} setShowEmi={setShowEmi} isLoading={isSearchApiLoading} setShowAnimation={setShowAnimation} processedData={processedData}/>
                            }  
                            </Collapse>

                            {isRT && showStudentFareStrip && (
                                <StudentFareFilter {...studentFilterProps}/>
                            )}

                            {!isSearchApiLoading && !isEmpty(sftFareType) && processedData?.isIntl && isRT && (
                                <PtcError cards={sortedFilteredCardsNoPTC} className="mb-6 mt-3" showPtcError={!isOnwardPtcFareAvailable && !isReturnPtcFareAvailable} />
                            )}
                            
                            {isSrpRevamp && !isRT ? (
                                /* The revamp uses one sort bar for both domestic and international one-way. */
                                <SortBarOneWay
                                    activeSort={activeSort}
                                    cheapestFilteredFlight={cheapestFilteredFlight}
                                    fastestFilteredFlight={fastestFilteredFlight}
                                    initialTS={initialTS}
                                    isLoading={isSearchApiLoading}
                                    J1from={J1from}
                                    processedData={processedData}
                                    setActiveSort={setActiveSort}
                                />
                            ) : (processedData?.isIntl || isSrpRevamp) && isRT ? (
                                <Collapse pose={showPeThemeChrome ? collapseState : 'open'} initial={collapseInitial}>
                                    <IntlRTSort
                                        isRevamp={isSrpRevamp}
                                        onwardLabel={processedData?.source}
                                        returnLabel={processedData?.destination}
                                        isLoading={isSearchApiLoading}
                                        onClick={onSortOptionClick}
                                        activeSort={activeSort}
                                        sortOptions={sortOptionsList?.[0] || []}
                                        sortOptionsReturn={sortOptionsList?.[1] || []}
                                        source={processedData?.source}
                                        destination={processedData?.destination}
                                        processedData={processedData}
                                        initialTS={initialTS}
                                    />
                                </Collapse>
                            ) : processedData?.isIntl && !isRT ? (
                                <SortOptions
                                    activeSort={activeSort}
                                    setActiveSort={setActiveSort}
                                    isRT={isRT}
                                    J1from={J1from}
                                    J2from={J2from}
                                    cheapestFilteredFlight={cheapestFilteredFlight}
                                    fastestFilteredFlight={fastestFilteredFlight}
                                    isLoading={isSearchApiLoading}
                                    processedData={processedData}
                                    initialTS={initialTS}
                                />
                            ) : (
                                fareType === 'FF' ? (
                                    isRT ? (
                                        <SortOptionsFFRT
                                            activeSort={activeSort}
                                            setActiveSort={setActiveSort}
                                            isLoading={isSearchApiLoading}
                                            processedData={processedData}
                                        />
                                    ) : (
                                        <SortOptionsFFOW
                                            activeSort={activeSort}
                                            setActiveSort={setActiveSort}
                                            isLoading={isSearchApiLoading}
                                            processedData={processedData}
                                        />
                                    )
                                ) : (
                                    <SortOptions
                                        activeSort={activeSort}
                                        setActiveSort={setActiveSort}
                                        isRT={isRT}
                                        J1from={J1from}
                                        J2from={J2from}
                                        cheapestFilteredFlight={cheapestFilteredFlight}
                                        fastestFilteredFlight={fastestFilteredFlight}
                                        isLoading={isSearchApiLoading}
                                        processedData={processedData}
                                    />
                                )
                            )}
                                {!isRT && showStudentFareStrip && (
                                    <StudentFareFilter {...studentFilterProps}/>
                                )}
                                {!isIntl && !isSrpRevamp && sftFareType && !isSearchApiLoading &&
                                    <PtcTupleRenedrer
                                    isSrpRevamp={isSrpRevamp}
                                    sortedFilteredCards={ptcFareCards}
                                    isRT={isRT}
                                    selectedFlights={selectedFlights}
                                    setSelectedFlights={setSelectedFlights}
                                    showPerAdultPricing={showPerAdultPricing}
                                    isLoading={isSearchApiLoading}
                                    searchQuery={searchQuery}
                                    resetFilters={resetFilters}
                                    processedData={processedData}
                                    selectedPrice={selectedPrice}
                                    selectedFilters={selectedFilters}
                                    fareType={fareType}
                                    cheapestFilteredFlight={cheapestRegularFare}
                                    isPTC = {true}
                                    activeSort={activeSort}
                                    unModifiedSortedFilteredCards={unModifiedSortedFilteredCards}
                                    showEmi={showEmi}
                                    setShowEmi={setShowEmi}
                                    pageScrollRef={pageScrollRef}
                                    updatedReturnListLength={updatedReturnListLength}
                                    setUpdatedReturnListLength={setUpdatedReturnListLength}
                                    onCollapseStateChange={handleCollapseStateChange}
                                    masterTuppleRef={masterTuppleRef}
                                    setShowAnimation={setShowAnimation}
                                />}
                            
                            <TuppleRenderer
                                sortedFilteredCards={sortedFilteredCardsNoPTC}
                                isRT={isRT}
                                selectedFlights={selectedFlights}
                                setSelectedFlights={setSelectedFlights}
                                showPerAdultPricing={showPerAdultPricing}
                                isLoading={isSearchApiLoading}
                                searchQuery={searchQuery}
                                resetFilters={resetFilters}
                                filterData={filterData}
                                processedData={processedData}
                                selectedPrice={selectedPrice}
                                selectedFilters={selectedFilters}
                                fareType={fareType}
                                initialTS={initialTS}
                                isPTC={isPtc}
                                activeSort={activeSort}
                                unModifiedSortedFilteredCards={unModifiedSortedFilteredCards}
                                showEmi={showEmi}
                                setShowEmi={setShowEmi}
                                pageScrollRef={pageScrollRef}
                                updatedReturnListLength={updatedReturnListLength}
                                setUpdatedReturnListLength={setUpdatedReturnListLength}
                                onCollapseStateChange={handleCollapseStateChange}
                                masterTuppleRef={masterTuppleRef}
                                setShowAnimation={setShowAnimation}
                                hasShownEmiTooltipRef={hasShownEmiTooltipRef}
                                toastHandler={(msg: string) => setToastMsg(msg)}
                                makeWowCardRef={makeWowCardRef}
                                isOnwardPtcFareAvailable={isOnwardPtcFareAvailable}
                                isReturnPtcFareAvailable={isReturnPtcFareAvailable}
                                srpCouponList={srpCouponList}
                                isSrpRevamp={isSrpRevamp}
                            />
                            {isRT && !isSearchApiLoading && !isFareFamilyFlow ? (
                                <MasterTupple
                                    legHasFlights={legHasFlights}
                                    selectedFlights={selectedFlights}
                                    couponData={couponData}
                                    isCouponApiLoading={isCouponApiLoading}
                                    processedData={processedData}
                                    showPerAdultPricing={showPerAdultPricing}
                                    searchData={searchData}
                                    searchQuery={searchQuery}
                                    paxCriteria={paxCriteria}
                                    initialTS={initialTS}
                                    hasShownEmiTooltipRef={hasShownEmiTooltipRef}
                                    masterTuppleRef={masterTuppleRef}
                                    {...masterTuppleData}
                                    toastHandler={(msg: string) => setToastMsg(msg)}
                                />
                            ) : (
                                ''
                            )}
                            {isSrpRevamp && masterTuppleFF}
                        </Container>
                            </>
                        )}
                    </Container>
                </Container>
            )}
            <SrpEmiBanksPopup searchData={searchData} searchQuery={searchQuery} />
            <Toast showIcon={toastMsg !== STUDENT_FARE_TOAST_MESSAGE} isVisible={!!toastMsg} message={toastMsg} containerClass="br-4 p-4 r-0 l-0 p-fixed" />
        </>
    )
    
}


export default SrpContainer
